import { styled } from '@mui/material';
import { breakpoints } from '@themes/theme.helpers';

const ColumnContainer = styled('div')<MultiColumnContentProps>`
  display: flex;
  flex-wrap: wrap;
  gap: ${(props) => props.theme.spacing(props.spacing || 2)};
  justify-content: stretch;
  & > * {
    flex: 1 1 100%;
    ${breakpoints.between('xs', 'md')} {
      flex: 1 1 50%;
    }
    ${breakpoints.up('md')} {
      flex: 1 1 ${(props) => 100 / (props?.columns ? props?.columns + 1 : 1)}%;
    }
  }
`;

export type MultiColumnContentProps = {
  spacing?: number;
  columns?: number;
  children?: React.ReactNode;
};

export const MultiColumnContent = ({ children, columns, spacing }: MultiColumnContentProps) => {
  return (
    <ColumnContainer columns={columns} spacing={spacing}>
      {children}
    </ColumnContainer>
  );
};
